import { render, staticRenderFns } from "./set_price_prod_regi.vue?vue&type=template&id=7e8ea9b2&"
import script from "./set_price_prod_regi.vue?vue&type=script&lang=js&"
export * from "./set_price_prod_regi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports